const PRODUCT_PUBLIC_CODE_PATTERN = /^[A-HJ-NP-Z2-9]{8}$/

export const normalizeProductPublicCode = (value: unknown): string | null => {
  if (typeof value !== 'string') return null
  const normalized = value.trim().toUpperCase()
  if (!PRODUCT_PUBLIC_CODE_PATTERN.test(normalized)) return null
  return normalized
}

export const buildShortProductPath = (publicCode: unknown): string | null => {
  const normalizedCode = normalizeProductPublicCode(publicCode)
  if (!normalizedCode) return null
  return `/dp/${encodeURIComponent(normalizedCode)}`
}

export const buildProductPathFromIdentity = ({
  publicCode,
  slug,
  categorySlugs = [],
}: {
  publicCode?: string | null
  slug: string
  categorySlugs?: string[]
}) => {
  const shortPath = buildShortProductPath(publicCode)
  if (shortPath) return shortPath

  const encodedSegments = [...categorySlugs, slug.trim()]
    .filter(Boolean)
    .map((segment) => encodeURIComponent(segment))
  if (!encodedSegments.length) return '/products'
  return `/products/${encodedSegments.join('/')}`
}
